import {useFormContext, Controller} from "react-hook-form"
import {TextField} from "@mui/material"
import PropTypes from "prop-types"

RHFTextField.propTypes = {
    name: PropTypes.string,
    helperText: PropTypes.node,
    other: PropTypes.object
}

export default function RHFTextField({name, helperText, ...other}) {
    const {control} = useFormContext()

    return (
        <Controller
            name={name}
            control={control}
            render={({field, fieldState: {error}}) => (
                <TextField
                    {...field}
                    fullWidth
                    value={field.value}
                    error={!!error}
                    helperText={error ? error?.message : helperText}
                    {...other}
                />
            )}
        />
    )
}